/**
 * Out-of-Home Advertising service page
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { MapPin, Target, Eye, CheckCircle } from 'lucide-react'

export default function OOHAdvertisingPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-green-900 via-green-800 to-emerald-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Out-of-Home Advertising</h1>
              <p className="text-xl text-green-100 leading-relaxed mb-8">
                Maximize your brand visibility with strategic outdoor advertising placements including 
                billboards, transit advertising, and premium outdoor media locations.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Go Outdoor</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/379a118c-4e0e-4783-8624-4033272c4562.jpg" 
                alt="Billboard Advertising"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">OOH Advertising Solutions</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-green-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Billboard Campaigns</h3>
                    <p className="text-gray-600">Prime location billboards for maximum visibility</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-green-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Transit Advertising</h3>
                    <p className="text-gray-600">Bus, metro, and airport advertising opportunities</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-green-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Digital Displays</h3>
                    <p className="text-gray-600">Dynamic digital outdoor advertising solutions</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-green-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Location Analytics</h3>
                    <p className="text-gray-600">Strategic placement based on traffic and demographics</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/30779ebc-fe9b-4960-9856-d1a7f4169bfe.jpg" 
                alt="Outdoor Advertising"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-green-900 to-emerald-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Go Big Outdoors?</h2>
          <p className="text-xl text-green-100 mb-8">
            Let us place your brand in the most visible locations for maximum impact
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Start OOH Campaign</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
